/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, March 13th 2022, 10:26:34 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { FormControl } from "@mui/material";
import { TagsInput } from "ui-widgets/tags/TagsInput";
import { useControlledInput } from "ui-widgets/forms";
import { TextFormInputProps } from "ui-widgets";
import {
  APIFormInputErrorWrapper,
  CustomInputValidationErrorWrapper,
  HelperTextInputWrapper,
} from "ui-widgets/forms/FormInputWrappers";

export type CommaSeparatedTagsFormInputProps<T> = TextFormInputProps<T>;

export const CommaSeparatedTagsFormInput = <T,>(props: CommaSeparatedTagsFormInputProps<T>) => {
  const {
    field: { onChange, value },
  } = useControlledInput<T>(props);

  const updateValues = React.useCallback((values: string[]) => {
    onChange(values.join(",") as any);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // onChange from react hook form is not a useCallback so do not include it in dependency list

  // Get Default values and ensure empty strings are not part of the values.
  const defaultValues = (value as string)?.split(",").filter((s) => s) ?? [];

  return (
    <APIFormInputErrorWrapper {...props}>
      <CustomInputValidationErrorWrapper {...props}>
        <HelperTextInputWrapper helperText={props.helperText}>
          <FormControl>
            <TagsInput {...props} multiline rows={4} defaultValues={defaultValues} onValuesChange={updateValues} />
          </FormControl>
        </HelperTextInputWrapper>
      </CustomInputValidationErrorWrapper>
    </APIFormInputErrorWrapper>
  );
};
